import { Provider } from "react-redux";
import styled from "styled-components";
import store from "app/store/store";
import GlobalStyle from "shared/styles/GlobalStyles";
import MainPage from "app/Mainpage";
import { QueryClientProvider, QueryClient } from "react-query";
import "./axiosConfig";
import { AutoLogoutProvider } from "shared/providers";

const queryClient = new QueryClient({});


function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Wrapper>
        <GlobalStyle />
        <Provider store={store}>

          <AutoLogoutProvider>
            <MainPage />
          </AutoLogoutProvider>

        </Provider>
      </Wrapper>
    </QueryClientProvider>
  );
}

export default App;

const Wrapper = styled.div`
  /* 100vh first as a fallback; dvh tracks the retracting mobile URL bar
     and is ignored by browsers that do not support it. */

  min-height: 100vh;

  min-height: 100dvh;
  min-width: 100%;
  background: var(--bg-body);
  display: flex;
  justify-content: center;

`;
